import { FC, useEffect, useRef, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import {
  Button,
  Input,
  Grid,
  Line,
  SelectForm,
  PhoneInput,
  InputMask
} from 'components'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import useLoading from 'hooks/useLoading'
import Draggable from 'react-draggable'
import { useForm } from 'react-hook-form'
import { ProfileUserServices } from 'services/Supplier/Users'
import { SPACING } from 'utils'
import { isValidCPF } from 'utils/functions'
import { PerfilUsuario } from 'utils/types'
import * as yup from 'yup'

import {
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled,
  FormDialog
} from './ModalNewUser.styles'
interface IModalNewUser {
  showModal: boolean
  toggleModal: () => void
  onSubmit: any
  emailUser?: string
  firstUser?: boolean
}

export interface NovoUsuarioForm {
  nuContato: string
  cdDocto: string
  nmUsuario: string
  txEmail: string
  perfilUsuarioId: number
}

const DEFAULT_FORM = {
  cdDocto: '',
  nmUsuario: '',
  nuContato: '',
  perfilUsuarioId: undefined,
  txEmail: ''
}
const ModalNewUser: FC<IModalNewUser> = ({
  firstUser = false,
  showModal,
  toggleModal,
  onSubmit,
  emailUser
}) => {

  const schema = yup
    .object({
      cdDocto: yup
        .string()
        .test('cdDocto', 'CPF Inválido', (value) => {
          if (value.length < 2) return false
          if (isNaN(parseInt(value))) return true
          return isValidCPF(value)
        })
        .test('cdDocto', 'Passaporte Inválido', (value) => {
          if (value.length < 2) return false
          if (!isNaN(parseInt(value))) return true
          return isValidPassaporte(value)
        })
        .required('Informe um CPF / Passaporte')
        //.transform((value) => value.replace(/[^\d]/g, ""))
        .max(14, 'CPF Inválido'),
      nmUsuario: yup
        .string()
        .required('Informe um nome.')
        .min(3, 'Informe nome completo'),
      nuContato: yup
        .string()
        .required('Informe numero para contato.')
        .transform((value) => value.replace(/[^\d]/g, ''))
        .min(10, 'Informe numero telefone válido. (11) 1111 - 1111'),
      perfilUsuarioId:
        !firstUser && yup.string().required('Informe um perfil.'),
      txEmail: yup
        .string()
        .required('Informe email.')
        .max(50, 'Máximo de caracteres ultrapassado.')
        //.email('Informe um e-mail válido.')
        .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Digite um email válido') 
    })
    .required()

  const [listProfiles, setListProfiles] = useState<PerfilUsuario[] | []>([])
  const { setLoading, setMsgErro } = useLoading()
  const {
    control,
    reset,
    handleSubmit,
    watch,
    setValue,
    formState: { errors }
  } = useForm<NovoUsuarioForm>({
    defaultValues: DEFAULT_FORM,
    resolver: yupResolver(schema)
  })

  const cpfPass = watch('cdDocto')

  const isValidPassaporte = (value: string) => {
    if (value.length < 2) return false
    return true
  }

  useEffect(() => {
    setValue('txEmail', emailUser)
  }, [emailUser])

  useEffect(() => {
    const getProfiles = async () => {
      setLoading('loading')
      try {
        const response = await ProfileUserServices().getSuppliers()
        setListProfiles(response.data)

        setLoading('idle')
      } catch (error) {
        setLoading('error')
        setMsgErro(error.toString())
      }
    }
    getProfiles()
  }, [])

  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      reference={draggableReference}
      showModal={showModal}
      width="md"
      onClose={() => {
        toggleModal()
        reset()
      }}
    >
      <Line />

      <FormDialog
        onSubmit={handleSubmit((data) => {
          onSubmit(data)
          reset()
          toggleModal()
          resetModalState(draggableReference)
        })}
      >
        <DialogTitleStyled>Novo Usuário</DialogTitleStyled>

        <DialogContentStyled>
          <Grid
            gridCols="2fr 1fr"
            gridGap="1rem"
            margin={`${SPACING.spacing10} 0 ${SPACING.spacing20} 0`}
          >
            <Input
              control={control}
              label="Colaborador"
              placeholder="Nome do Colaborador"
              formValue="nmUsuario"
              errors={errors}
              required
            />
            <Input
              label="CPF / Passaporte"
              placeholder="Nº"
              mask={
                isNaN(parseInt(cpfPass)) ? ['NN##########'] : ['###.###.###-##']
              }
              formValue="cdDocto"
              maxLength={isNaN(parseInt(cpfPass)) ? 99 : 14}
              control={control}
              errors={errors}
              defaultValue="."
              required
            />
          </Grid>
          <Grid gridCols="2.2fr 1fr 1.8fr" gridGap="1rem" margin="1rem 0 0 0">
            <InputMask
              disabled={Boolean(emailUser)}
              label="E-mail"
              type="email"
              placeholder="E-mail"
              formValue="txEmail"
              control={control}
              errors={errors}
              maxLength={50}
              required
            />
            <PhoneInput
              label="Contato"
              placeholder="+000 (00) 0000-0000"
              formValue="nuContato"
              control={control}
              errors={errors}
              required
            />

            <SelectForm
              control={control}
              errors={errors}
              label="Perfil"
              disabled={firstUser ? true : false}
              required
              defaultValue={emailUser && emailUser?.length > 0 ? 9 : ''}
              formValue="perfilUsuarioId"
              listOptions={listProfiles}
              labelMenu="txDenominacao"
              valueMenu="idPerfilUsuario"
            />
          </Grid>
        </DialogContentStyled>

        <DialogActionsStyled>
          <Button
            text="Voltar"
            variantButton="outlined"
            onClick={() => {
              toggleModal()
              resetModalState(draggableReference)
            }}
          />
          <Button text="Salvar" type="submit" />
        </DialogActionsStyled>
      </FormDialog>
    </DraggableDialog>
  )
}

export default ModalNewUser
